import { z } from "zod";

import { AtomRecordSchema } from "./atom.js";
import { CellRecordSchema } from "./cell.js";
import { PositionEvaluationSchema } from "./evaluation.js";
import {
  AtomIdSchema,
  IsoTimestampSchema,
  JsonObjectSchema,
  PositionIdSchema,
} from "./common.js";

export const LineStateSchema = z.object({
  selectedPathId: AtomIdSchema.optional(),
});
export type LineState = z.infer<typeof LineStateSchema>;

export const BoardStateSchema = z.object({
  atoms: z.record(AtomIdSchema, AtomRecordSchema),
  cells: z.record(z.string().min(1), CellRecordSchema),
  line: LineStateSchema,
});
export type BoardState = z.infer<typeof BoardStateSchema>;

export const PositionMoveKindSchema = z.enum([
  "root",
  "atom.upsert",
  "cell.upsert",
  "line.select",
  "proof.record",
]);
export type PositionMoveKind = z.infer<typeof PositionMoveKindSchema>;

export const PositionRecordSchema = z.object({
  createdAt: IsoTimestampSchema,
  depth: z.number().int().nonnegative(),
  evaluation: PositionEvaluationSchema,
  id: PositionIdSchema,
  moveKind: PositionMoveKindSchema,
  movePayload: JsonObjectSchema.optional(),
  moveSummary: z.string(),
  parentPositionId: PositionIdSchema.optional(),
  stateHash: z.string().min(1),
  stateSnapshot: BoardStateSchema,
});
export type PositionRecord = z.infer<typeof PositionRecordSchema>;
